import Vue from 'vue'
import Router from 'vue-router'
import AppNavBar from './components/AppNavbar.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/Home.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: () => import('./views/Login.vue')
      } 
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/signup',
      name: 'signUp',
      components: {
        content: () => import('./views/SignUp.vue')
      } 
    },
    {
      path: '/request-reset-password',
      name: 'requestResetPassword',
      components: {
        content: () => import('./views/RequestResetPassword.vue')
      } 
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      components: {
        content: () => import('./views/ResetPassword.vue')
      } 
    },
    {
      path: '/member-management/approvalbymember',
      name: 'memberApproval',
      components: {
        content: () => import('./views/MemberApproval.vue')
      } 
    },
    // App Transaction Route
    {
      path: '/purchase-order',
      name: 'appPO',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/PurchaseOrder.vue')
      } 
    },
    {
      path: '/purchase-order/detail',
      name: 'appPODetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/PurchaseOrderDetail.vue')
      }
    },
    {
      path: '/request-sample',
      name: 'requestSample',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/RequestSample.vue')
      } 
    },
    {
      path: '/request-sample/detail',
      name: 'requestSampleDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/RequestSampleDetail.vue')
      } 
    },
    {
      path: '/request-sample/approval',
      name: 'requestSampleApproval',
      components: {
        content: () => import('./views/transaction/RequestSampleApproval.vue')
      } 
    },
    {
      path: '/request-sample/declined',
      name: 'requestSampleDeclined',
      components: {
        content: () => import('./views/transaction/RequestSampleDeclined.vue')
      } 
    },
    {
      path: '/approved-quality',
      name: 'approvedQuality',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/ApprovedQuality.vue')
      } 
    },
    {
      path: '/approved-quality/detail',
      name: 'approvedQualityDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/ApprovedQualityDetail.vue')
      } 
    },
    {
      path: '/approved-quality/approval',
      name: 'approvedQualityApproval',
      components: {
        content: () => import('./views/transaction/ApprovedQualityApproval.vue')
      } 
    },
    {
      path: '/approved-quality/revised',
      name: 'approvedQualityRevised',
      components: {
        content: () => import('./views/transaction/ApprovedQualityRevised.vue')
      } 
    },
    {
      path: '/customer-gateway',
      name: 'customerGateway',
      components: {
        content: () => import('./views/transaction/CustomerGateway.vue')
      } 
    },
    {
      path: '/customer-gateway/detail',
      name: 'customerGatewayDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/CustomerGatewayDetail.vue')
      } 
    },
    {
      path: '/sample-journey',
      name: 'sampleJourney',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/SampleJourney.vue')
      } 
    },
    {
      path: '/sample-journey/detail',
      name: 'sampleJourneyDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/SampleJourneyDetail.vue')
      } 
    },
    {
      path: '/mail-management',
      name: 'mailManagement',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/MailManagement.vue')
      } 
    },
    {
      path: '/mail-management/detail',
      name: 'mailManagementDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/MailManagementDetail.vue')
      } 
    },
    {
      path: '/member-management',
      name: 'memberManagement',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/MemberManagement.vue')
      } 
    },
    {
      path: '/member-management/detail',
      name: 'memberManagementDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/MemberManagementDetail.vue')
      } 
    },
    {
      path: '/user-profile',
      name: 'userProfile',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/UserProfile.vue')
      } 
    },
    {
      path: '/report-request-sample',
      name: 'rptRequestSample',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/report/ReportRequestSample.vue')
      } 
    },
    {
      path: '/print/request-sample',
      name: 'requestSamplePartial',
      components: {
        content: () => import('./views/report/RequestSamplePartial.vue')
      } 
    }
  ]
})
